export default "__VITE_ASSET__CxZfoyfD__"